import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Popover,
  Stack,
} from "@mui/material";
// import { FlagIcon, FlagIconCode } from "react-flag-kit";
import { Language, useConfigStore } from "../../store/config";
import Loading from "../Loading";
import { saveUserRecordLanguage } from "../../api/admin";

interface optionItem {
  code: Language;
  name: string;
  flag: string;
}

function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const [language, updateLanguage] = useConfigStore((state) => [
    state.language,
    state.updateLanguage,
  ]);

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const handleChange = (language: optionItem) => {
    const value = language.code || "en";
    setAnchorEl(null);
    setIsLoading(true)
    saveUserRecordLanguage(value).then(() => {
      updateLanguage(value);
      i18n.changeLanguage(value);
      setTimeout(() => {
        window.location.reload();
      }, 10);
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const languageOptions: optionItem[] = [
    { code: "en", name: "English", flag: "US" },
    { code: "zhCN", name: "中文（简）", flag: "CN" },
    { code: "jp", name: "日本語", flag: "JP" },
  ];
  const countryFlag = useMemo(() => {
    let flag;
    switch (language) {
      case "en":
        flag = "US";
        break;
      case "zhCN":
        flag = "CN";
        break;
      case "jp":
        flag = "JP";
        break;
      default:
        break;
    }
    return flag;
  }, [language]);

  return (
    <>
      <Stack onClick={handleClick} direction={"row"} alignItems={"center"}>
        <ListItemButton>
          {countryFlag && (
            <>
              <ListItemIcon sx={{ minWidth: "20px", marginRight: 1 }}>
                <img
                  src={require(`../../assets/images/country-flag/${countryFlag}.svg`)}
                  // height={18}
                  alt={countryFlag}
                ></img>
              </ListItemIcon>
              <ListItemText primary={t('common.languageSwitch')} />
            </>
          )}
        </ListItemButton>
      </Stack>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Paper>
          <Stack direction="column">
            {languageOptions.map((language) => (
              <ListItemButton
                key={language.code}
                onClick={() => {
                  handleChange(language);
                }}
              >
                <ListItemIcon sx={{ minWidth: "30px" }}>
                  <img
                    src={require(`../../assets/images/country-flag/${language.flag}.svg`)}
                    alt={language.code}
                  ></img>
                </ListItemIcon>
                <ListItemText primary={language.name} sx={{ marginRight: 5 }} />
              </ListItemButton>
            ))}
          </Stack>
        </Paper>
      </Popover>
      <Loading open={isLoading} wording={t("common.loadingText")} />
    </>
  );
}

export default LanguageSwitcher;
